import styled from "styled-components"

export const SelectStatusWrapper = styled.div`
    position: relative;
    display: table;
    width: calc(100% - 40px);
`
export const Status = styled.div`
    display: flex;
    width: fit-content;
    float: left;
    margin: 2px 5px 2px 0;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 13px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.taskStatusColor};
    background: ${(props) => props.theme.taskStatusBackground};
`
export const CloseButton = styled.div`
    user-select: none;
    margin-left: 7px;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: 10px;
        color: ${(props) => props.theme.taskStatusCloseButtonColor};
        transition: 0.1s ease;

        &:hover {
            color: ${(props) => props.theme.taskStatusCloseButtonHoverColor};
            transition: 0.1s ease;
        }
    }
`
export const ClearButton = styled.div`
    position: absolute;
    right: -16px;
    top: 50%;
    transform: translateY(-50%);
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.taskStatusClearButtonBackground};
    user-select: none;
    cursor: pointer;
    
    & > i {
        font-weight: bold;
        font-size: 10px;
        color: ${(props) => props.theme.taskStatusClearButtonColor};
        transition: 0.1s ease;
    }
    
    &:hover {
        background: ${(props) => props.theme.taskStatusClearButtonHoverBackground};
        transition: 0.1s ease;
        
        & > i {
            color: ${(props) => props.theme.taskStatusClearButtonHoverColor};
            transition: 0.1s ease;
        }
    }
`
